<div class="input-group flex-nowrap">
  <span class="input-group-text"><i class="bi {{ iconClass }}"></i> </span>
  <input [(ngModel)]="localValue" (ngModelChange)="onValueChange($event)" type="email"
    class="form-control form-control-lg" placeholder="{{ placeholder }}" />
</div>
